<template>
  <div class="APIError">
    <ErrorContent :error-code="errorCode" :error-text="errorText" :error-id="errorId" :include-stack-trace="includeStackTrace" :stack-trace="stackTrace">
      <template v-slot:footer>
        <p>
          Please
          <button class="btn-link" @click="handleTryAgain">try again</button> later or
          <a
            href="mailto: ea@thebuildingblocks.org"
            rel="external noopener"
            target="_blank"
            >contact our support team</a
          >
          for further assistance.
        </p>
      </template>
    </ErrorContent>
  </div>
</template>

<script>
import ErrorContent from './ErrorContent'
import { API_ERROR_SUBTYPES } from '@/constants'

export default {
  name: 'APIError',
  props: {
    error: {
      type: Object,
      default: () => ({})
    },
    includeStackTrace: {
      type: Boolean,
      default: false
    },
    previousRoute: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      API_ERROR_SUBTYPES
    }
  },
  components: {
    ErrorContent
  },
  computed: {
    errorObject() {
      return this.error.errorObject || {}
    },
    stackTrace() {
      return this.errorObject.stack || null
    },
    response() {
      return this.error.response || {}
    },
    errorList() {
      return (this.response.data && this.response.data.errors) || []
    },
    codeText() {
      return (
        (this.errorList[0] && this.errorList[0].error_code) ||
        this.error.fallbackCode
      )
    },
    codeStatus() {
      return (
        (this.errorList[0] && this.errorList[0].status) ||
        (this.isNetworkError(this.errorObject) && 'NET') ||
        this.response.status
      )
    },
    errorCode() {
      return (
        (this.codeText &&
          this.codeStatus &&
          `${this.codeText}-${this.codeStatus}`) ||
        null
      )
    },
    errorId() {
      return (this.errorList[0] && this.errorList[0].id) || null
    },
    errorText() {
      switch (this.codeText) {
        case this.API_ERROR_SUBTYPES.initiateAuth:
          return 'Sorry, we are unable to authenticate you right now.'
        case this.API_ERROR_SUBTYPES.submit:
          return 'Sorry, we are unable to submit your application right now.'
        case this.API_ERROR_SUBTYPES.getApplication:
          return 'Sorry, we are unable to retrieve your application at this time.'
        default:
          return 'An error has occurred and we’re trying to fix the problem.'
      }
    }
  },
  methods: {
    handleTryAgain() {
      switch (this.codeText) {
        case this.API_ERROR_SUBTYPES.getApplication:
          // To handle the oauth login case where the prevousRoute will be set as '/login/auth' after users login
          this.$router.push('/login/resume')
          return
        case this.API_ERROR_SUBTYPES.submit:
        case this.API_ERROR_SUBTYPES.initiateAuth:
        default:
          this.previousRoute.name
            ? this.$router.push(this.previousRoute.fullPath)
            : this.$router.go(-1)
      }
    },
    isNetworkError(e) {
      return e.message === 'Network Error'
    }
  }
}
</script>

<style lang="scss" scoped>
.typed-email-headline {
  color: $color-red;
  line-height: normal;
  font-weight: bold;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
</style>
